<template>
  <div class="mt-3">
    <v-toolbar dense color="grey lighten-2" tabs>
      <v-toolbar-title>{{ pageTitle }}</v-toolbar-title>

      <v-spacer></v-spacer>

      <div v-show="showSearch">
        <v-text-field 
          @input="search" 
          v-model="searchTerm" 
          prepend-inner-icon="search" 
          clearable
          autofocus
        ></v-text-field>
      </div>
      <slot name="adicionaAtividade"></slot>
      <!-- <v-tooltip bottom>
        <ModalCadastro slot="activator" />
        <span>Adicionar</span>
      </v-tooltip> -->
      
      <v-tooltip bottom>
        <v-btn flat icon small slot="activator" @click="showSearch = !showSearch">
          <v-icon>{{ iconSearch }}</v-icon>
        </v-btn>
        <span>Pesquisar</span>
      </v-tooltip>

      <v-tooltip bottom>
        <v-btn flat icon small slot="activator" @click="$emit('refreshAtividadesCliente')">
          <v-icon>refresh</v-icon>
        </v-btn>
        <span>Atualizar</span>
      </v-tooltip>

      <v-tooltip bottom>
        <span>Opções</span>
        <v-menu bottom left slot="activator">
          <v-btn flat icon small slot="activator">
            <v-icon>more_vert</v-icon>
          </v-btn>
          <v-list>
            <v-list-tile @click='$emit("editItemSelected")'>
              <v-list-tile-title>
                <v-icon small left>edit</v-icon>Alterar
              </v-list-tile-title>
            </v-list-tile>
            <v-list-tile @click='$emit("deleteItemSelected")'>
              <v-list-tile-title>
                <v-icon small left>delete</v-icon>Excluir
              </v-list-tile-title>
            </v-list-tile>
            <v-list-tile @click='$emit("finalizaItemSelected")'>
              <v-list-tile-title>
                <v-icon small left>check</v-icon>Finalizar
              </v-list-tile-title>
            </v-list-tile>
            <v-list-tile @click='$emit("voltaStatusItemSelected")'>
              <v-list-tile-title>
                <v-icon small left>undo</v-icon>Voltar Status
              </v-list-tile-title>
            </v-list-tile>
            <v-list-tile @click='$emit("abreModalDuplicaAtividade", null)'>
              <v-list-tile-title>
                <v-icon small left>event</v-icon>Duplicar Atividade
              </v-list-tile-title>
            </v-list-tile>
            <v-list-tile @click='$emit("abreModalEditPrevisao", null)'>
              <v-list-tile-title>
                <v-icon small left>event</v-icon>Setar Previsão
              </v-list-tile-title>
            </v-list-tile>
            <v-list-tile @click='$emit("abreModalEditSituacao", null)'>
              <v-list-tile-title>
                <v-icon small left>description</v-icon>Setar Situação
              </v-list-tile-title>
            </v-list-tile>
            <v-list-tile @click='$emit("abreModalEditResponsavel", null)'>
              <v-list-tile-title>
                <v-icon small left>person</v-icon>Setar Responsável
              </v-list-tile-title>
            </v-list-tile>
            <v-list-tile @click='$emit("abreModalEditTipoAtividade", null)'>
              <v-list-tile-title>
                <v-icon small left>label_important</v-icon>Setar Tipo Atividade
              </v-list-tile-title>
            </v-list-tile>
            <v-list-tile @click='$emit("abreModalEditColaborador", null)'>
              <v-list-tile-title>
                <v-icon small left>group_add</v-icon>Setar Colaborador
              </v-list-tile-title>
            </v-list-tile>
            <v-list-tile @click='$emit("abreModalEditCliente", null)'>
              <v-list-tile-title>
                <v-icon small left>group_add</v-icon>Setar Cliente
              </v-list-tile-title>
            </v-list-tile>
            <v-list-tile @click='$emit("abreModalEditTag", null)'>
              <v-list-tile-title>
                <v-icon small left>label</v-icon>Setar Tag
              </v-list-tile-title>
            </v-list-tile>
            <v-list-tile @click='$emit("abreModalSetaOcorrencia", null)'>
              <v-list-tile-title>
                <v-icon small left>comment</v-icon>Setar Ocorrência
              </v-list-tile-title>
            </v-list-tile>
            <v-list-tile @click='$emit("abreModalEditWorkflow", null)'>
              <v-list-tile-title>
                <v-icon small left>label</v-icon>Setar Workflow
              </v-list-tile-title>
            </v-list-tile>
          </v-list>
        </v-menu>
      </v-tooltip>

      <template v-slot:extension>
        <v-tabs v-model="tab" color="grey lighten-2" grow>
          <v-tabs-slider color="grey darken-4"></v-tabs-slider>

          <v-tab>Pendentes ({{ qtdePendentes }})</v-tab>
          <v-tab>Finalizadas ({{ qtdeFinalizadas }})</v-tab>
          <v-tab>Todas ({{ qtdeAtividades }})</v-tab>
        </v-tabs>
      </template>
    </v-toolbar>

    <v-tabs-items v-model="tab">
      <v-tab-item>
        <v-card flat>
          <v-card-text class="pa-0">
            <slot name="pendentes"></slot>
          </v-card-text>
        </v-card>
      </v-tab-item>
      <v-tab-item>
        <v-card flat>
          <v-card-text class="pa-0">
            <slot name="finalizadas"></slot>
          </v-card-text>
        </v-card>
      </v-tab-item>
      <v-tab-item>
        <v-card flat>
          <v-card-text class="pa-0">
            <slot name="todas"></slot>
          </v-card-text>
        </v-card>
      </v-tab-item>
    </v-tabs-items>
  </div>
</template>

<script>
import { clearTimeout, setTimeout } from 'timers';
import ModalCadastro from '@/components/atividade/ModalCadastro';

export default {
  props: ["pageTitle", "qtdeAtividades", "qtdePendentes", "qtdeFinalizadas"],
  components: {
    ModalCadastro
  },
  data() {
    return {
      tab: null,
      searchTerm: '',
      showSearch: false,
      timeout: null
    };
  },
  methods: {
    search() {
      clearTimeout(this.timeout);

      this.timeout = setTimeout(() => {
        this.$emit('searchAtividade', this.searchTerm);
      }, 500);
    }
  },
  computed: {
    iconSearch() {
      return this.showSearch ? 'clear' : 'search';
    }
  }
};
</script>

<style>
</style>